import React from 'react';
import { motion } from 'framer-motion';
export function StarFlourish({
  className = '',
  delay = 0
}: {
  className?: string;
  delay?: number;
}) {
  return <motion.svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} initial={{
    opacity: 0,
    scale: 0,
    rotate: -45
  }} animate={{
    opacity: [0.4, 1, 0.4],
    scale: [0.8, 1.2, 0.8],
    rotate: 0
  }} transition={{
    duration: 3,
    repeat: Infinity,
    delay,
    ease: 'easeInOut'
  }} data-id="element-18">
      <path d="M12 0L13.5 8.5L22 10L13.5 11.5L12 20L10.5 11.5L2 10L10.5 8.5L12 0Z" fill="currentColor" data-id="element-19" />
    </motion.svg>;
}
export function OrnateDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-4 w-full max-w-md mx-auto opacity-60 ${className}`} data-id="element-20">
      <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent flex-1" data-id="element-21" />
      <StarFlourish className="text-gold w-4 h-4" data-id="element-22" />
      <div className="w-2 h-2 rounded-full bg-carrot" data-id="element-23" />
      <StarFlourish className="text-gold w-4 h-4" delay={1} data-id="element-24" />
      <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent flex-1" data-id="element-25" />
    </div>;
}
export function MagicHatWithCarrot({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-26">
      {/* Glow behind */}
      <circle cx="100" cy="100" r="80" fill="url(#carrotGlow)" opacity="0.4" data-id="element-27" />

      {/* The Carrot (emerging) */}
      <path d="M100 120 C 100 120, 80 50, 90 30 C 100 10, 110 10, 120 30 C 130 50, 100 120, 100 120 Z" fill="#ea580c" data-id="element-28" />
      {/* Carrot lines */}
      <path d="M95 50 L 115 55 M 92 70 L 110 75 M 95 90 L 105 92" stroke="#9a3412" strokeWidth="3" strokeLinecap="round" data-id="element-29" />

      {/* Carrot Greens */}
      <path d="M95 30 C 80 10, 70 20, 75 35 C 80 50, 95 30, 95 30 Z" fill="#22c55e" data-id="element-30" />
      <path d="M105 25 C 105 0, 120 5, 115 25 C 110 45, 105 25, 105 25 Z" fill="#16a34a" data-id="element-31" />
      <path d="M115 30 C 130 15, 140 25, 130 40 C 120 55, 115 30, 115 30 Z" fill="#15803d" data-id="element-32" />

      {/* The Top Hat */}
      <ellipse cx="100" cy="140" rx="60" ry="15" fill="#1e293b" data-id="element-33" />
      <path d="M60 140 L 65 80 C 65 75, 135 75, 135 80 L 140 140 Z" fill="#0f172a" data-id="element-34" />
      {/* Hat Band */}
      <path d="M62 120 L 138 120 L 140 140 C 140 145, 60 145, 60 140 Z" fill="#ea580c" data-id="element-35" />
      {/* Hat Brim Highlight */}
      <ellipse cx="100" cy="140" rx="58" ry="13" stroke="#334155" strokeWidth="2" fill="none" data-id="element-36" />

      {/* Sparkles around */}
      <path d="M40 60 L 45 70 L 55 75 L 45 80 L 40 90 L 35 80 L 25 75 L 35 70 Z" fill="#fbbf24" data-id="element-37" />
      <path d="M150 40 L 153 48 L 161 51 L 153 54 L 150 62 L 147 54 L 139 51 L 147 48 Z" fill="#fbbf24" data-id="element-38" />

      <defs data-id="element-39">
        <radialGradient id="carrotGlow" cx="0.5" cy="0.5" r="0.5" data-id="element-40">
          <stop offset="0%" stopColor="#fde68a" data-id="element-41" />
          <stop offset="100%" stopColor="#fde68a" stopOpacity="0" data-id="element-42" />
        </radialGradient>
      </defs>
    </svg>;
}